import clsx from 'clsx';
import { Eyebrow } from './Eyebrow';

export type CalloutSize = 'sm' | 'md' | 'lg';
export type CalloutAlign = 'left' | 'right' | 'center';

export interface NumberCalloutProps {
  eyebrow: string;
  value: string | number;
  unit?: string;
  size?: CalloutSize;
  align?: CalloutAlign;
  className?: string;
  prefixEyebrow?: boolean;
}

const sizeClasses: Record<CalloutSize, string> = {
  sm: 'text-[20px]',
  md: 'text-[32px]',
  lg: 'text-[48px]',
};

const alignClasses: Record<CalloutAlign, string> = {
  left: 'text-left items-start',
  right: 'text-right items-end',
  center: 'text-center items-center',
};

export function NumberCallout({
  eyebrow,
  value,
  unit,
  size = 'md',
  align = 'left',
  className,
  prefixEyebrow = true,
}: NumberCalloutProps) {
  return (
    <div className={clsx('flex flex-col gap-2', alignClasses[align], className)}>
      <Eyebrow prefix={prefixEyebrow}>{eyebrow}</Eyebrow>
      <span
        className={clsx(
          'font-display font-light font-tnum leading-none text-ink',
          sizeClasses[size],
        )}
      >
        {value}
        {unit ? <small className="ml-1.5 text-ink-subtle text-[0.5em]">{unit}</small> : null}
      </span>
    </div>
  );
}
